module.exports = __webpack_public_path__ + "media/images/banners/session-annual2025-e10dafab3e61a274fd964dca697cf78e.png";